import { configureStore } from '@reduxjs/toolkit';
import uiSlice from './uiSlice';
import dataSlice from './dataSlice';
import authSlice from './auth-Slice';

const store = configureStore({
    reducer: { ui: uiSlice.reducer, data: dataSlice.reducer, auth: authSlice.reducer }
});

export default store;